import React from 'react';
import { Helmet } from 'react-helmet-async';

export const LocalBusinessSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "RealEstateAgent",
                "@id": "https://pro-byty.cz/#identity",
                "name": "PRO-BYTY.cz",
                "url": "https://pro-byty.cz",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://imagedelivery.net/2OhTeUm5dT07PSQroFepFw/40be5d28-47ca-4830-fcae-0a3ee9e60200/public"
                },
                "image": "https://imagedelivery.net/2OhTeUm5dT07PSQroFepFw/40be5d28-47ca-4830-fcae-0a3ee9e60200/public",
                "description": "Specializujeme se na prodej kompletně zrekonstruovaných bytů v Praze. Kvalita, design a jistota.",
                "telephone": "+420-777-123-456",
                "email": "asistentka@pro-byty.cz",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Praha",
                    "addressCountry": "CZ"
                },
                "priceRange": "$$$"
            },
            {
                "@type": "WebSite",
                "@id": "https://pro-byty.cz/#website",
                "url": "https://pro-byty.cz",
                "name": "PRO-BYTY.cz",
                "description": "Rekonstrukce a prodej bytů v Praze",
                "publisher": {
                    "@id": "https://pro-byty.cz/#identity"
                }
            },
            {
                "@type": "WebPage",
                "@id": "https://pro-byty.cz/#webpage",
                "url": "https://pro-byty.cz",
                "name": "PRO-BYTY.cz - Prodej rekonstruovaných bytů v Praze",
                "isPartOf": {
                    "@id": "https://pro-byty.cz/#website"
                },
                "about": {
                    "@id": "https://pro-byty.cz/#identity"
                },
                "description": "Prodáváme byty po kompletní rekonstrukci v Praze. Každý byt je pečlivě navržen a realizován naším týmem.",
                "breadcrumb": {
                    "@id": "https://pro-byty.cz/#breadcrumb"
                },
                "inLanguage": "cs-CZ"
            },
            {
                "@type": "BreadcrumbList",
                "@id": "https://pro-byty.cz/#breadcrumb",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Domů",
                        "item": "https://pro-byty.cz"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Koupit byt",
                        "item": "https://pro-byty.cz/koupit-byt"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "Prodat byt",
                        "item": "https://pro-byty.cz/prodat-byt"
                    }
                ]
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export default LocalBusinessSchema;
